/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetReportingAccountsTransactions200,
  GetReportingAccountsTransactionsParams,
  GetReportingCardaccountsTransactions200,
  GetReportingCardaccountsTransactionsParams
} from './schema'



/**
 * @summary Download account transactions
 */
export const getReportingAccountsTransactions = (
    params?: GetReportingAccountsTransactionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetReportingAccountsTransactions200>> => {
    return axios.get(
      `/reporting/accounts/transactions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetReportingAccountsTransactionsQueryKey = (params?: GetReportingAccountsTransactionsParams,) => [`/reporting/accounts/transactions`, ...(params ? [params]: [])];

    
export type GetReportingAccountsTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getReportingAccountsTransactions>>>
export type GetReportingAccountsTransactionsQueryError = AxiosError<unknown>

export const useGetReportingAccountsTransactions = <TData = Awaited<ReturnType<typeof getReportingAccountsTransactions>>, TError = AxiosError<unknown>>(
 params?: GetReportingAccountsTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReportingAccountsTransactions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportingAccountsTransactionsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportingAccountsTransactions>>> = ({ signal }) => getReportingAccountsTransactions(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getReportingAccountsTransactions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * @summary Download  card account transactions
 */
export const getReportingCardaccountsTransactions = (
    params?: GetReportingCardaccountsTransactionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetReportingCardaccountsTransactions200>> => {
    return axios.get(
      `/reporting/cardaccounts/transactions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetReportingCardaccountsTransactionsQueryKey = (params?: GetReportingCardaccountsTransactionsParams,) => [`/reporting/cardaccounts/transactions`, ...(params ? [params]: [])];

    
export type GetReportingCardaccountsTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getReportingCardaccountsTransactions>>>
export type GetReportingCardaccountsTransactionsQueryError = AxiosError<unknown>

export const useGetReportingCardaccountsTransactions = <TData = Awaited<ReturnType<typeof getReportingCardaccountsTransactions>>, TError = AxiosError<unknown>>(
 params?: GetReportingCardaccountsTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReportingCardaccountsTransactions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportingCardaccountsTransactionsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportingCardaccountsTransactions>>> = ({ signal }) => getReportingCardaccountsTransactions(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getReportingCardaccountsTransactions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

